import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import {
  faDownload,
  faEye,
  faInfoCircle,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import * as uuid from "uuid";
import { FileUpload } from "../../model/domain/File";
import { PagedList } from "../../model/domain/PagedList";
import { AuthService } from "../../services/auth.service";
import { DialogService } from "../../services/dialog.service";
import { DownloadService } from "../../services/download.service";
import { FileService } from "../../services/file.service";
import { LoaderService } from "../../services/loader.service";
import { SecurityService } from "../../services/security.service";
import { SnackbarService } from "../../services/snackbar.service";
import { Roles } from "../auth/auth.role";
import { FileType } from "./../../enum/file-type.enum";

@Component({
  selector: "app-attachment",
  templateUrl: "./attachment.component.html",
  styleUrls: ["./attachment.component.scss"],
})
export class AttachmentComponent implements OnInit, OnChanges {
  @Input() ticketId: any = null;
  @Input() canEdit: boolean;
  @Input() canChangeStatus: boolean;
  @Input() keepEditableForAdminFiduci: boolean;
  @Input() statusDescription: string = "";
  @Input() filterByGroup: number = null;
  @Output() tempTicketId = new EventEmitter<any>();
  @Output() uploadedFilesCount = new EventEmitter<number>();
  private sanitizer: DomSanitizer;

  faDownload = faDownload;
  faTrash = faTrash;
  faInfoCircle = faInfoCircle;
  faEye = faEye;

  constructor(
    private authService: AuthService,
    private snackBarService: SnackbarService,
    private loaderService: LoaderService,
    private fileService: FileService,
    private dialogService: DialogService,
    private downloadService: DownloadService,
    private securityService: SecurityService
  ) {
    this.tempId = uuid.v4();
  }

  @ViewChild("thisInput") inputFile: ElementRef;

  // Paginação
  defaultPage = 1;
  defaultPageSize = 10;
  pageSizeSelected = this.defaultPageSize;
  uploadPageSize: number = this.defaultPageSize;
  uploadTotalPages: number = null;
  uploadTotalItems: number = null;
  uploadListedPages: any[];
  uploadFirstItemOnPage: number;
  uploadLastItemOnPage: number;
  uploadCurrentPage: number = this.defaultPage;
  viewFileModalBase64: any = null;
  model: any;
  tempId: any = null;
  file: File;
  Files: FileUpload[] = [];

  ColumnsFile: string[] = [
    "name",
    "createDate",
    "createUser",
    "userType",
    "actions",
  ];

  roles: number[] = [];
  canDelete: any[] = [];
  canShow = true;

  ngOnChanges(): void {
    this.reset();
    this.modelInit();
  }

  reset() {
    this.tempId = uuid.v4();
    this.pageSizeSelected = this.defaultPageSize;
    this.uploadPageSize = this.defaultPageSize;
    this.uploadCurrentPage = this.defaultPage;
    this.uploadTotalPages = null;
    this.uploadTotalItems = null;
    this.uploadListedPages = [];
    this.uploadFirstItemOnPage;
    this.uploadLastItemOnPage;
    this.model = null;
    this.file = null;
    this.Files = [];
    this.roles = [];
    this.canDelete = [];
    this.canShow = true;
  }

  ngOnInit() {
    this.modelInit();
  }

  modelInit() {
    this.loadFilesPaged();
  }

  loadFilesPaged(page: number = null, pageSize: number = null) {
    const params: any[] = [];

    if (page) {
      params.push(page);
    } else {
      params.push(this.uploadCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.uploadPageSize = pageSize;
    } else if (this.uploadPageSize) {
      params.push(this.uploadPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.fileService
      .getFilesPaginatedAttachment(
        this.tempId,
        this.ticketId,
        FileType.Attachment,
        page,
        pageSize,
        this.filterByGroup
      )
      .subscribe((files: any) => {
        if (files) {
          this.Files = files.results;
          this.renderPaginatorFile(files);
          files.results.forEach((file) => {
            this.setIsRemovable(file.id, file.creationUser);
          });
        } else {
          this.Files = [];
        }
      });
  }

  renderPaginatorFile(result: PagedList<any>) {
    this.uploadTotalItems = result.rowCount;
    this.uploadTotalPages = result.pageCount;
    this.uploadFirstItemOnPage = result.firstRowOnPage;
    this.uploadLastItemOnPage = result.lastRowOnPage;

    this.uploadCurrentPage = result.currentPage;

    this.uploadListedPages = [];

    let startPage = this.uploadCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.uploadCurrentPage + 2;
    while (maxPage > this.uploadTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.uploadListedPages.push(i);
    }

    if (!result.results.length) {
      this.uploadTotalPages = 1;
      this.uploadCurrentPage = 1;
      this.uploadFirstItemOnPage = 0;

      this.uploadListedPages = [];
      this.uploadListedPages.push(1);
    }

    this.uploadedFilesCount.emit(result.rowCount);
  }

  canViewMonitor() {
    const roles = [Roles.ViewUploadTransferMonitor];
    return this.authService.hasRoles(roles);
  }

  canUploadTransfer() {
    const roles = [Roles.CreateTicketPrivateFixedIncome];
    return this.authService.hasRoles(roles);
  }

  canUploadDistributor() {
    const roles = [Roles.CreateLiabilitiesTicket];
    return this.authService.hasRoles(roles);
  }

  canApproveUpload() {
    const roles = [Roles.ApprovePendingApprovalAdm];
    return this.authService.hasRoles(roles);
  }

  delete(id: number) {
    this.fileService.delete(id).subscribe((res) => this.modelInit());
  }

  openFile(event) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
    }
  }

  openPdf(name: string) {
    var isPdf = name.includes(".pdf");

    const download = this.fileService.download(name);

    return download.subscribe((data: Blob) => {
      this.dialogService.modalFile(data, isPdf);
    });
  }

  isValidFile(fileName: String): boolean {
    return (
      fileName.includes(".pdf") ||
      fileName.includes(".jpeg") ||
      fileName.includes(".png") ||
      fileName.includes(".jpg")
    );
  }

  download(name: string) {
    const download = this.fileService.download(name);

    return download.subscribe(
      (data: Blob) => {
        this.downloadService.downloadFile(data, name);

        this.loaderService.removeLoader();
      },
      () => {
        this.loaderService.removeLoader();

        this.snackBarService.open(
          "Não foi possível fazer o download do arquivo.",
          "OK"
        );
      }
    );
  }

  submit() {
    this.tempTicketId.emit(this.tempId);
    this.fileService
      .uploadAttachment(this.file, this.tempId, this.ticketId)
      .subscribe(() => {
        this.modelInit();
        this.clearFileInput();
      });
  }

  clearFileInput() {
    this.inputFile.nativeElement.value = "";
    this.file = null;
  }

  async canRemove(createUser: string) {
    return await this.authService.rolesByUsername(createUser).toPromise();
  }

  setIsRemovable(id: number, createUser: string) {
    return this.canRemove(createUser).then((res) => {
      this.roles = res;
      const isGestor = this.authService.authToken.isAccountManager;
      const myRoles = this.roles.filter((z) => (isGestor ? z === 2 : z === 10));
      const isRemovable = this.authService.hasRoles(myRoles);

      this.canDelete.push({ id, isRemovable });
      return Promise.resolve(res);
    });
  }

  canDeleteFile(index: number): boolean {
    const canDelete = this.canDelete.find((x) => x.id === index);
    return canDelete && canDelete.isRemovable;
  }

  isExternalUserToText(isExternalUser: boolean) {
    return isExternalUser ? "Externo" : "Interno";
  }

  keepEditable(): boolean {
    return (
      this.keepEditableForAdminFiduci ||
      (this.statusDescription == null &&
        this.authService.authToken.isAccountManager)
    );
  }
}
